import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Spinner,
} from 'reactstrap';
import { Controller } from 'react-hook-form';
import usePropertySalesInfo from '../../hooks/usePropertySalesInfo';
import SalesFinancialFields from './SalesFinancialFields';
import { CURRENCY_SYMBOLS, percentFields } from './salesFields';

interface Props {
  currency?: string;
  // Formulario compartido con las otras tarjetas de venta (una sola instancia, creada en la pantalla).
  salesInfo: ReturnType<typeof usePropertySalesInfo>;
}

// Valores financieros en una sola tarjeta y con un solo botón: reserva y prima (con ellas se arma
// el plan de pagos de la web) más los indicadores de inversión (ROI, IRR, porcentaje de ganancias).
// El botón guarda el formulario completo de información de venta.
const SalesFinancialCard = ({ currency = 'USD', salesInfo }: Props) => {
  const { control, errors, submitSalesInfo, isLoading, propertySalesInfo } =
    salesInfo;
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency;

  return (
    <Card>
      <CardHeader className="py-3">
        <h3 className="mb-0">Valores financieros</h3>
      </CardHeader>
      <CardBody className="py-3">
        <SalesFinancialFields
          control={control}
          errors={errors}
          symbol={symbol}
          missingReservePrice={!propertySalesInfo?.reserve_price}
        />
        <Row>
          {percentFields.map(({ name, label }) => (
            <Col lg="3" md="6" key={name}>
              <FormGroup className="mb-3">
                <label className="form-control-label" htmlFor={name}>
                  {label}
                </label>
                <Controller
                  name={name}
                  control={control}
                  render={({ field }) => (
                    <InputGroup>
                      <Input
                        {...field}
                        id={name}
                        type="number"
                        min={0}
                        step={0.1}
                        className={`text-dark ${
                          errors[name]?.message ? 'is-invalid' : ''
                        }`}
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>%</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  )}
                />
                {errors[name]?.message && (
                  <h5 className="text-danger mt-1 mb-0">
                    {errors[name]?.message}
                  </h5>
                )}
              </FormGroup>
            </Col>
          ))}
        </Row>
      </CardBody>
      <CardFooter className="text-right py-3">
        <Button
          type="button"
          color="primary"
          disabled={isLoading}
          onClick={() => submitSalesInfo()}
        >
          {isLoading && <Spinner size="sm" className="mr-2" />}
          Guardar valores financieros
        </Button>
      </CardFooter>
    </Card>
  );
};

export default SalesFinancialCard;
